import { prependOrg } from '@signavio/effektif-api'
import * as pathToRegexpModule from 'path-to-regexp-6'

const casePatterns = () => [
  prependOrg('/cases/overview/:processId'),
  prependOrg('/cases/case/:caseId'),
]

const taskPatterns = () => [
  prependOrg('/cases/tasks/:tab'),
  prependOrg('/cases/case/:caseId/task/:taskId'),
]

const workflowPatterns = () => [
  prependOrg('/processes'),
  prependOrg('/processes/overview'),
  prependOrg('/processes/process/:processId/(.*)'),
]

const reportPatterns = () => [
  prependOrg('/analytics'),
  prependOrg('/analytics/report/:reportId/(.*)'),
]

const matchesPattern = (patterns: string[], pathname: string) =>
  patterns.some((path) => pathToRegexpModule.pathToRegexp(path).test(pathname))

export const getSearchUrl = (pathname: string) => {
  if (matchesPattern(taskPatterns(), pathname)) {
    return prependOrg('/search/tasks')
  }

  if (matchesPattern(casePatterns(), pathname)) {
    return prependOrg('/search/cases')
  }

  if (matchesPattern(workflowPatterns(), pathname)) {
    return prependOrg('/search/processes')
  }

  if (matchesPattern(reportPatterns(), pathname)) {
    return prependOrg('/search/reports')
  }

  return prependOrg('/search')
}

export const isProcessEditorPage = (pathname: string) => {
  const processEditorUrlRegex = prependOrg('/processes/process/:processId/(.*)')
  return matchesPattern([processEditorUrlRegex], pathname)
}

export const isAnalyticsPage = (pathname: string) => {
  return matchesPattern(reportPatterns(), pathname)
}
